<template>
	<StaticViewComponent :content="content"></StaticViewComponent>
</template>

<script>

import StaticViewComponent from "@/components/StaticViewComponent";

export default {
	props: {},
	metaInfo: {
		title: 'Политика конфиденциальности',
		meta: [
			{name: 'theme-color', content: '#F7F3ED'},
			{name: 'apple-mobile-web-app-capable', content: 'yes'},
			{name: 'apple-mobile-web-app-status-bar-style', content: 'yes'},
			// <meta name="apple-mobile-web-app-capable" content="yes">
			// <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
			// {vmid: 'description', property: 'description', content: 'Vue App'},
			// {vmid: 'og:title', property: 'og:title', content: 'Vue App'},
			// {vmid: 'og:description', property: 'og:description', content: 'Vue App'},
		],
	},
	components: {
		StaticViewComponent,
	},
	data() {
		return {
			content: `
				<h4 style="font-weight: bold; text-align: center; margin-bottom: 2em; color: #2C3333">Политика конфиденциальности</h4>
				<br>
				<p>Настоящая Политика конфиденциальности персональной информации (далее &mdash; Политика) действует в
					отношении всей информации, которую юридическое лицо ООО &laquo;Три сферы&raquo; (150545, Ярославская
					область, Ярославский район, п. Дубки, ул. Школьная д.1 оф.43 (ИНН 7627051991, ОГРН 1197627008116)) и/или
					его аффилированные лица, могут получить о пользователе во время использования им сайта&nbsp;https://dolphin-hotel.ru
				</p>

				<p>Использование сайта&nbsp;https://dolphin-hotel.ru&nbsp;означает безоговорочное согласие пользователя с
					настоящей Политикой и указанными в ней условиями обработки его персональной информации; в случае
					несогласия с этими условиями пользователь должен воздержаться от использования данного ресурса.
				</p>

				<p style="color: #2C3333; font-weight: bold;">1.&nbsp;Персональная информация пользователей, которую получает и обрабатывает сайт&nbsp;https://dolphin-hotel.ru
				</p>

				<p>1.1. В рамках настоящей Политики под &laquo;персональной информацией пользователя&raquo; понимаются:</p>

				<p>1.1.1. Персональная информация, которую пользователь предоставляет о себе самостоятельно при оставлении
					заявки, совершении покупки, регистрации (создании учётной записи) или в ином процессе использования
					сайта.</p>

				<p>1.1.2 Данные, которые автоматически передаются сайтом&nbsp;https://dolphin-hotel.ru&nbsp;в процессе его
					использования с помощью установленного на устройстве пользователя программного обеспечения, в том числе
					IP-адрес, информация из cookie, информация о браузере пользователя (или иной программе, с помощью которой
					осуществляется доступ к сайту), время доступа, адрес запрашиваемой страницы.</p>

				<p>1.1.3. Данные, которые предоставляются сайту, в целях осуществления оказания услуг и/или продаже товара
					и/или предоставления иных ценностей для посетителей<br/>
					сайта&nbsp;https://dolphin-hotel.ru, в соответствии с деятельностью настоящего ресурса:</p>

				<div>
					<ul style="padding-left: 1.5em">
						<li>
							фамилия
						</li>
						<li>
							имя
						</li>
						<li>
							отчество
						</li>
						<li>
							электронная почта
						</li>

						<li>
							номер телефона
						</li>

					</ul>

				</div>

				<p>1.2. Настоящая Политика применима только к сайту&nbsp;https://dolphin-hotel.ru&nbsp;и не контролирует и не
					несет ответственность за сайты третьих лиц, на которые пользователь может перейти по ссылкам, доступным на
					сайте&nbsp;https://dolphin-hotel.ru. На таких сайтах у пользователя может собираться или запрашиваться иная
					персональная информация, а также могут совершаться иные действия.</p>

				<p>1.3. Сайт в общем случае не проверяет достоверность персональной информации, предоставляемой
					пользователями, и не осуществляет контроль за их дееспособностью.</p>

				<p>Однако сайт&nbsp;https://dolphin-hotel.ru&nbsp;исходит из того, что пользователь предоставляет достоверную и
					достаточную персональную информацию по вопросам, предлагаемым в формах настоящего ресурса, и поддерживает
					эту информацию в актуальном состоянии.</p>

				<p style="color: #2C3333; font-weight: bold;">2. Цели сбора и обработки персональной информации пользователей</p>

				<p>2.1. Сайт собирает и хранит только те персональные данные, которые необходимы для оказания услуг и/или
					продаже товара и/или предоставления иных ценностей для посетителей сайта&nbsp;https://dolphin-hotel.ru.</p>

				<p>2.2. Персональная информация пользователя используется в следующих целях:</p>

				<table class="policy_table" border="1" cellpadding="8" cellspacing="0">
					<thead>
						<tr>
							<th>№</th>
							<th>Цель обработки</th>
							<th>Категории субъектов</th>
							<th>Перечень обрабатываемых ПДн</th>
							<th>Сроки обработки и хранения</th>
							<th>Порядок уничтожения</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1.</td>
							<td>Для регистрации пользователя на сайте</td>
							<td>Пользователи сайта (посетители, клиенты)</td>
							<td>фамилия, имя, отчество, электронная почта, номер телефона</td>
							<td>До достижения цели обработки или до отзыва согласия</td>
							<td>Путем безвозвратного удаления из баз данных с обязательным оформлением бумажного или электронного акта</td>
						</tr>
						<tr>
							<td>2.</td>
							<td>Для осуществления обратной связи с клиентом, предоставления клиентской поддержки</td>
							<td>Пользователи сайта (посетители, клиенты)</td>
							<td>фамилия, имя, отчество, электронная почта, номер телефона</td>
							<td>До достижения цели обработки или до отзыва согласия</td>
							<td>Путем безвозвратного удаления из баз данных с обязательным оформлением бумажного или электронного акта</td>
						</tr>
						<tr>
							<td>3.</td>
							<td>Для таргетирования информационных и рекламных материалов</td>
							<td>Пользователи сайта (посетители, клиенты)</td>
							<td>фамилия, имя, отчество, электронная почта, номер телефона</td>
							<td>До достижения цели обработки или до отзыва согласия</td>
							<td>Путем безвозвратного удаления из баз данных с обязательным оформлением бумажного или электронного акта</td>
						</tr>
					</tbody>
				</table>

				<p style="color: #2C3333; font-weight: bold;">3. Условия обработки персональной информации пользователя и её передачи третьим лицам</p>

				<p>3.1. Сайт&nbsp;https://dolphin-hotel.ru.&nbsp;хранит персональную информацию пользователей в соответствии с
					внутренними регламентами конкретных сервисов.</p>

				<p>3.2. В отношении персональной информации пользователя сохраняется ее конфиденциальность, кроме случаев
					добровольного предоставления пользователем информации о себе для общего доступа неограниченному кругу
					лиц.</p>

				<p>3.3. Сайт&nbsp;https://dolphin-hotel.ru.&nbsp;вправе передать персональную информацию пользователя третьим
					лицам в следующих случаях:</p>

				<p>3.3.1. Пользователь выразил свое согласие на такие действия, путем согласия выразившегося в предоставлении
					таких данных;</p>

				<p>3.3.2.&nbsp;Передача необходима в рамках использования пользователем определенного сайта&nbsp;https://dolphin-hotel.ru,
					либо для предоставления товаров и/или оказания услуги пользователю;</p>

				<p>3.3.3. Передача предусмотрена российским или иным применимым законодательством в рамках установленной
					законодательством процедуры;</p>

				<p>3.3.4. В целях обеспечения возможности защиты прав и законных интересов сайта или третьих лиц в случаях,
					когда пользователь нарушает Пользовательское соглашение сайта&nbsp;https://dolphin-hotel.ru.</p>

				<p>3.4. При обработке персональных данных пользователей<br/>
					сайт&nbsp;https://dolphin-hotel.ru.&nbsp;руководствуется Федеральным законом РФ &laquo;О персональных данных&raquo;.
				</p>

				<p style="color: #2C3333; font-weight: bold;">4. Изменение пользователем персональной информации</p>

				<p>4.1. Пользователь может в любой момент изменить (обновить, дополнить) предоставленную им персональную
					информацию или её часть, а также параметры её конфиденциальности, через личный кабинет сайта, а в случае
					его отсутствия, оставив заявление в адрес администрации сайта следующим способом:</p>

				<p>Телефон: 8-4852-62-00-11 Email:&nbsp;info@yardelfin.ru</p>

				<p>4.2. Пользователь может в любой момент, отозвать свое согласие на обработку персональных данных, оставив
					заявление в адрес администрации сайта следующим способом:</p>

				<p>Телефон:&nbsp;8-4852-62-00-11<br/>
								Email:&nbsp;info@yardelfin.ru</p>

				<p>4.3. Обрабатываемые персональные данные уничтожаются по достижению целей обработки или в случае отзыва согласия на обработку персональных данных посетителем сайта.</p>

				<p>В случае достижения цели обработки персональных данных или отзыва согласия субъектом персональных данных Оператор обязан прекратить обработку персональных данных и уничтожить персональные данные в срок, не превышающий тридцати дней с даты достижения цели обработки персональных данных или отзыва согласия.</p>

								<p style="color: #2C3333; font-weight: bold;">5. Меры, применяемые для защиты персональной информации пользователей</p>

				<p>Сайт принимает необходимые и достаточные организационные и технические меры для защиты персональной
					информации пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования,
					копирования, распространения, а также от иных неправомерных действий с ней третьих лиц.</p>

				<p style="color: #2C3333; font-weight: bold;">6. Изменение Политики конфиденциальности. Применимое законодательство.</p>

				<p>6.1. Сайт имеет право вносить изменения в настоящую Политику конфиденциальности. При внесении изменений в
					актуальной редакции указывается дата последнего обновления. Новая редакция Политики вступает в силу с
					момента ее размещения на сайте&nbsp;https://dolphin-hotel.ru, если иное не предусмотрено новой редакцией
					Политики.
				</p>
			`
		}
	},
	computed: {

	},
	// 	base_url: process.env.BASE_URL
	// },
	// mounted() {
	// 	this.$refs.goToTopAnchor.click()
	// },
	methods: {}
};
</script>

<style scoped>
.back_to_home_box {
	position: fixed;
	right: 15px;
	top: 55px;
	z-index: 1000;
}

.back_to_home,
.back_to_home:hover {
	color: #333333;
	text-decoration: none;
	font-size: 80px;
	line-height: 50px;
	opacity: 0.9;
}

.back_to_home:hover {
	opacity: 0.5;
}

p { text-indent: 2em; color: #333333; }

.policy_table {
	width: 100%;
	font-size: 14px;
	color: #333333;
	border-collapse: collapse;
	margin: 1em 0;
}

.policy_table th {
	text-align: left;
	background: #F7F3ED;
	color: #2C3333;
}

.policy_table td, .policy_table th {
	padding: 8px;
	vertical-align: top;
}

h4, .section-heading { color: #2C3333; }
</style>
